// src/features/services/components/ServiceInfoCard.tsx
import { Card, formatPersianNumber, formatSolarDate } from '../../../app/components/foundation';
import type { Service } from '../types/service.types';
import { ServiceStatusBadge } from './ServiceStatusBadge';

export interface ServiceInfoCardProps {
  service: Service;
}

/**
 * Workspace card: core service info. Pulls straight off the base
 * Service record (same shape the list table already uses) — no
 * additional mock data needed for this one.
 */
export function ServiceInfoCard({ service }: ServiceInfoCardProps) {
  return (
    <Card className="vania-service-workspace-card">
      <h2 className="vania-service-workspace-card-title">اطلاعات سرویس</h2>

      <dl className="vania-service-workspace-fieldlist">
        <div>
          <dt>نام سرویس</dt>
          <dd>{service.name}</dd>
        </div>
        <div>
          <dt>نوع سرویس</dt>
          <dd>{service.type}</dd>
        </div>
        <div>
          <dt>وضعیت</dt>
          <dd>
            <ServiceStatusBadge status={service.status} />
          </dd>
        </div>
        <div>
          <dt>شناسه سرویس</dt>
          <dd>{formatPersianNumber(service.id)}</dd>
        </div>
        <div>
          <dt>شناسه تننت</dt>
          <dd>{formatPersianNumber(service.tenant_id)}</dd>
        </div>
        <div>
          <dt>شناسه یکتا</dt>
          <dd>{service.slug}</dd>
        </div>
        <div>
          <dt>توضیحات</dt>
          <dd>{service.description ?? '—'}</dd>
        </div>
        <div>
          <dt>تاریخ ایجاد</dt>
          <dd dir="ltr">{formatSolarDate(service.created_at)}</dd>
        </div>
        <div>
          <dt>آخرین به‌روزرسانی</dt>
          <dd dir="ltr">{formatSolarDate(service.updated_at)}</dd>
        </div>
      </dl>
    </Card>
  );
}
